import React, { Component } from 'react';

import { Col, Row, Button, Container, Table}  from 'react-bootstrap';

import {Rest} from "../../Helpers/Rest" 
import InfoBlock from "../../Components/InfoBlock/InfoBlock"
import PropTypes from 'prop-types';
import Uploads from "../../Components/Uploads/Uploads"
import Form from "../../Components/Form/Form"
import Comments from "../../Components/Comments/Comments"

var method = "create";
var id = false;
 


export default class FormContainer extends Component {
    
    state = {
        data:{}
    }

    componentDidMount = () => {
        method = this.props.match.params.method
        id = this.props.match.params.id

        if(id){
            var rest = new Rest(this)
            rest.request("feedbacks", "READ", {id: id}, (res)=>{ 
                this.setState({
                    data: res
                })
            })
        }
    };

    save = () =>{ 
        this.setState({
            errors: false,
            success: false
        })
        var data = this.state.data
        var rest = new Rest(this)
        var rest_method = "CREATE"
        if(method=="edit"){
            rest_method = "UPDATE"
        }
        if(this.state.uploads){
            data['uploads'] = this.state.uploads.map(u=>u.id)
        }
        rest.request("feedbacks", rest_method, data, (res)=>{ 
             if(!res.errors){
                 this.setState({
                     success: ["Saved"]
                 })
                 setTimeout(()=>{
                     window.location.href = "/feedbacks/list"
                 }, 500)
             }
        })
    }
    
  render() {
      console.log(this.state)
    return (
        <Container>
            <Row className="mt-3 mb-3">
            <Col>
                <h4>
                    { method==="edit"? "Edit feedback category" : "Add feedback category"}
                </h4>
            </Col>
            </Row>

            {
                this.state.errors && <InfoBlock data={this.state.errors} variant="danger" />
            }
            {
                this.state.success && <InfoBlock data={this.state.success} variant="info" />
            }
            
            <Row className="mt-3 center">
            <Col>
                <Row className="d-flex justify-content-center bg-light">
                    <Col className="">
                        <Form
                            fields = {
                              [ 
                                {
                                  name: "status",
                                  label: "Status",
                                  as: "select",
                                  options:[
                                        {
                                            label: "New",
                                            value: "new"
                                        },
                                        {
                                            label: "In progress",
                                            value: "in_progress"
                                        },
                                        {
                                            label: "Closed",
                                            value: "closed"
                                        }
                                    ]

                                },  
                              ]
                            }
                            store_to={"data"}
                            _this = {this}
                        />
                        <div className="mb-3"> 
                            <Button className="btn-block" variant="dark" onClick={this.save}>
                                        Save
                            </Button>
                        </div>
                        <div>
                            <b>Created at:</b> {this.state.data.created_at} 
                        </div>
                        <div>
                            <b>Title:</b> {this.state.data.name} 
                        </div>
                        <div>
                            <b>Body:</b> {this.state.data.body} 
                        </div> 
                    </Col>
                    <Col> 
                        <div>
                            Attachments: 
                            <div>
                            { this.state.data.id && <Uploads
                                label={""}
                                max={0}
                                table_name={"feedbacks"}
                                record_id={this.state.data.id}
                                variant="preview"
                                base64={true}
                                readonly={true}
                                accept="image/*"
                            />} 
                            </div>
                        </div>
                    </Col>
                </Row> 
                <hr/>
                <Row>
                    <Col>
                        { this.state.data.id && <Comments
                            table_name={"feedbacks"}
                            record_id={this.state.data.id}
                            readonly={false}
                        />} 
                    
                    </Col>
                </Row>
            </Col>
        </Row>

        </Container>
    );
  }
}



FormContainer.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            id: PropTypes.string,
            method: PropTypes.string
        })
    }), 
}